



















import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';
import { useActivePerformances } from '@/composables/performances';

import { ScenkonstPerformanceListingBlockDataFragment } from '@/graphql/generated';
import { ComposableMixin } from '@/mixins/composable';
import { PageBlockMixin } from '@/modules/cms';

@Component({
  graphqlData: gql`
    fragment ScenkonstPerformanceListingBlockData on ScenkonstPerformanceListingBlock {
      id
      title
      performanceTags {
        id
        title
      }
      ...BlockColor
    }

    ${blockableBlockColorFragment}
  `,
})
export default class ScenkonstPerformanceListingBlock extends mixins(
  PageBlockMixin<ScenkonstPerformanceListingBlockDataFragment>(),
  blockColorMixin,
  ComposableMixin(useActivePerformances, ({ data }) => {
    return [{
      performanceTags: data.performanceTags.map(tag => tag.id),
    }];
  }),
) {}
